(() => {
  angular
    .module('complianceFrameworkApp.vms')
    .config(routes);

  /* ngInject */
  function routes($stateProvider) {
    $stateProvider
      .state('application.vms.assessment-notifications', {
        url: '/vendors/:vendorId/assessment/notifications',
        params: { notifiable_type: 'assessment' },
        views: {
          '@application.vms': {
            templateUrl: '/templates/vms/notifications/notifications.html',
            controller: 'NotificationsController',
            controllerAs: 'vm'
          }
        }
      })

      .state('application.vms.contract-notifications', {
        url: '/vendors/:vendorId/contracts/:id/notifications',
        params: { notifiable_type: 'contract' },
        views: {
          '@application.vms': {
            templateUrl: '/templates/vms/notifications/notifications.html',
            controller: 'NotificationsController',
            controllerAs: 'vm'
          }
        }
      })

      .state('application.vms.document-requirement-notifications', {
        url: '/vendors/:vendorId/document_requirements/:id/notifications',
        params: { notifiable_type: 'document_requirement' },
        views: {
          '@application.vms': {
            templateUrl: '/templates/vms/notifications/notifications.html',
            controller: 'NotificationsController',
            controllerAs: 'vm'
          }
        }
      })
      ;
  }
})();
